"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsonConvert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class JsonConvert {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "json");
    (0, _defineProperty2.default)(this, "label", "JSON");
    (0, _defineProperty2.default)(this, "description", "Convert a JSON encoded string into an object.");
    (0, _defineProperty2.default)(this, "settings", {});
  }
  create(deps, batcher) {
    return value => {
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch (err) {
          console.warn("Unable to parse JSON in JsonConvert: " + err.message);
        }
      }
      return null;
    };
  }
  dependencies(context, params, resolver) {
    return undefined;
  }
  editorLabel(params) {
    return "";
  }
}
exports.JsonConvert = JsonConvert;
//# sourceMappingURL=JsonConvert.js.map